import { render } from "./S71807.vue?vue&type=template&id=5e6c30e9"
const script = {}
script.render = render

export default script